// extracted by mini-css-extract-plugin
export default {"noResultPreviewText":"NoSearchResultsTextContainer_noResultPreviewText__n-P6P"};